import { Link } from "react-router-dom";

const articles = [
  {
    slug: "/guia-cssbuy-sheet",
    title: "Guia Definitivo do CSSBuy Spreadsheet",
    excerpt: "Aprenda a encontrar os melhores vendedores, utilizar links atualizados e navegar com segurança no universo CSSBuy.",
    image: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20showing%20organized%20spreadsheet%20beside%20a%20steaming%20ceramic%20coffee%20mug%20and%20small%20potted%20succulent%20plant%20on%20warm%20oak%20wooden%20desk%20soft%20natural%20daylight%20from%20window%20clean%20minimal%20composition%20editorial%20style%20European%20aesthetic%20knowledge%20theme&width=600&height=450&seq=home-article-1-v2&orientation=landscape",
    date: "Junho 2026",
  },
  {
    slug: "/melhores-links-cssbuy",
    title: "Melhores Links CSSBuy 2026",
    excerpt: "Guia completo de acesso e organização dos links mais atualizados para suas compras de streetwear e moda.",
    image: "https://readdy.ai/api/search-image?query=Clean%20desk%20workspace%20with%20laptop%20displaying%20colorful%20organized%20link%20categories%20beside%20neatly%20folded%20premium%20beige%20sweater%20and%20minimalist%20notebook%20warm%20natural%20light%20from%20side%20window%20creating%20soft%20shadows%20editorial%20photography%20calm%20productive%20atmosphere&width=600&height=450&seq=home-article-2-v2&orientation=landscape",
    date: "Junho 2026",
  },
  {
    slug: "/vendedores-cssbuy-confiaveis",
    title: "Vendedores CSSBuy Confiáveis",
    excerpt: "Como identificar e escolher fornecedores verificados para garantir compras seguras e produtos de qualidade.",
    image: "https://readdy.ai/api/search-image?query=Professional%20workspace%20setup%20with%20laptop%20showing%20verified%20seller%20badges%20and%20five%20star%20reviews%20beside%20neatly%20arranged%20leather%20accessories%20and%20folded%20denim%20on%20light%20marble%20desk%20surface%20soft%20natural%20window%20lighting%20editorial%20style%20confident%20trustworthy%20atmosphere&width=600&height=450&seq=home-article-3-v2&orientation=landscape",
    date: "Junho 2026",
  },
  {
    slug: "/cssbuy-guia-seguranca",
    title: "Guia de Segurança CSSBuy",
    excerpt: "Proteja suas compras e seus dados pessoais com nossas recomendações completas de segurança online.",
    image: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20shield%20security%20icon%20and%20lock%20symbols%20beside%20carefully%20placed%20leather%20wallet%20and%20smartphone%20on%20light%20cream%20desk%20surface%20soft%20diffused%20morning%20light%20through%20sheer%20curtains%20creating%20calm%20protected%20atmosphere%20editorial%20photography%20European%20aesthetic&width=600&height=450&seq=home-article-4-v2&orientation=landscape",
    date: "Junho 2026",
  },
  {
    slug: "/cssbuy-yupoo-guide",
    title: "CSSBuy Yupoo: Guia Definitivo",
    excerpt: "Aprenda a navegar pelos álbuns Yupoo e encontrar os melhores produtos com os vendedores certos.",
    image: "https://readdy.ai/api/search-image?query=Clean%20desk%20with%20laptop%20showing%20product%20gallery%20grid%20and%20fashion%20item%20thumbnails%20beside%20neatly%20arranged%20sneakers%20and%20cap%20on%20light%20oak%20wooden%20surface%20warm%20natural%20daylight%20from%20large%20window%20creating%20bright%20productive%20atmosphere%20editorial%20style%20modern%20workspace&width=600&height=450&seq=home-article-5-v2&orientation=landscape",
    date: "Junho 2026",
  },
  {
    slug: "/streetwear-spreadsheet-guide",
    title: "Streetwear Spreadsheet Guide",
    excerpt: "Organize suas compras de moda urbana com planilhas especializadas e monte looks completos.",
    image: "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20streetwear%20fashion%20items%20including%20graphic%20hoodie%20vintage%20sneakers%20and%20minimalist%20accessories%20arranged%20artistically%20on%20textured%20concrete%20surface%20soft%20natural%20daylight%20creating%20gentle%20shadows%20urban%20aesthetic%20modern%20magazine%20quality%20warm%20neutral%20tones&width=600&height=450&seq=home-article-6-v2&orientation=landscape",
    date: "Junho 2026",
  },
  {
    slug: "/replica-sneakers-guia",
    title: "Guia de Réplicas de Sneakers",
    excerpt: "Descubra como avaliar qualidade, comparar preços e encontrar os melhores sneakers disponíveis.",
    image: "https://readdy.ai/api/search-image?query=Carefully%20arranged%20premium%20sneakers%20in%20cream%20and%20beige%20tones%20on%20light%20marble%20surface%20with%20soft%20natural%20shadows%20minimalist%20editorial%20composition%20featuring%20detailed%20textures%20and%20stitching%20lifestyle%20fashion%20photography%20warm%20neutral%20palette%20clean%20modern%20aesthetic&width=600&height=450&seq=home-article-7-v2&orientation=landscape",
    date: "Junho 2026",
  },
  {
    slug: "/cssbuy-shipping-guide",
    title: "CSSBuy Shipping Guide",
    excerpt: "Entenda opções de envio, prazos e custos para planejar suas compras com máxima eficiência.",
    image: "https://readdy.ai/api/search-image?query=Clean%20workspace%20with%20laptop%20displaying%20delivery%20routes%20and%20shipping%20tracking%20information%20beside%20neatly%20stacked%20small%20cardboard%20boxes%20on%20light%20wooden%20desk%20warm%20natural%20window%20light%20organized%20professional%20atmosphere%20modern%20logistics%20editorial%20style%20European%20aesthetic&width=600&height=450&seq=home-article-8-v2&orientation=landscape",
    date: "Junho 2026",
  },
  {
    slug: "/cssbuy-dicas-iniciantes",
    title: "CSSBuy para Iniciantes",
    excerpt: "10 dicas essenciais para quem está começando no mundo das compras internacionais com CSSBuy.",
    image: "https://readdy.ai/api/search-image?query=Warm%20cozy%20workspace%20with%20laptop%20showing%20welcome%20screen%20beside%20a%20notebook%20with%20handwritten%20checklist%20and%20steaming%20mug%20of%20coffee%20on%20light%20oak%20desk%20soft%20golden%20morning%20sunlight%20streaming%20through%20window%20creating%20inviting%20beginner%20friendly%20atmosphere%20editorial%20photography%20European%20aesthetic&width=600&height=450&seq=home-article-9-v2&orientation=landscape",
    date: "Junho 2026",
  },
];

export default function ArticleGridSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="text-xs uppercase tracking-[0.2em] text-foreground-500 font-heading">
            Guias e Artigos SEO
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mt-2">
            Guias Completos para CSSBuy
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-2xl">
            Artigos detalhados escritos por especialistas independentes para ajudar você a dominar o universo CSSBuy.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, idx) => (
            <Link
              key={article.slug}
              to={article.slug}
              className={`group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer flex flex-col ${
                idx === 0 ? "sm:col-span-2 lg:col-span-2 lg:flex-row" : ""
              }`}
            >
              <div className={`overflow-hidden bg-background-200 ${idx === 0 ? "lg:w-1/2 aspect-[16/10] lg:aspect-auto" : "aspect-[16/10]"}`}>
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className={`p-5 flex flex-col justify-center ${idx === 0 ? "lg:w-1/2" : ""}`}>
                <span className="text-xs text-foreground-400 font-heading">{article.date}</span>
                <h3 className={`font-heading font-semibold text-foreground-900 mt-1.5 mb-2 leading-snug group-hover:text-primary-600 transition-colors ${idx === 0 ? "text-xl md:text-2xl" : "text-base md:text-lg"}`}>
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 mt-3 group-hover:gap-2 transition-all">
                  Ler Artigo
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}